export const QUOTE_ROUTES = [
  {
    path: '/quotes',
    name: 'QuoteList',
    component: () => import('./views/QuoteList.vue'),
  },
  {
    path: '/quotes/create',
    name: 'CreateQuote',
    component: () => import('./views/CreateQuote.vue'),
  },
  {
    path: '/quotes/my-drafts',
    name: 'MyDraftQuotes',
    component: () => import('./views/MyDrafts.vue'),
  },

  {
    path: '/quotes/pending',
    name: 'PendingQuotes',
    component: () => import('./views/PendingQuotes.vue'),
  },
  {
    path: '/quotes/:id/edit',
    name: 'EditQuote',
    component: () => import('./views/EditQuote.vue'),
  },
  {
    path: '/quotes/present',
    name: 'PresentQuotes',
    component: () => import('./views/PresentQuotes.vue'),
  },
]
